/** Where a mailbox preview button sends the file. Flag on stays in the app. */
export type MailboxPreviewTarget = 'shell' | 'tab';

export function mailboxPreviewTarget(emailArchiveEnabled: boolean): MailboxPreviewTarget {
  return emailArchiveEnabled ? 'shell' : 'tab';
}
